import React, { useEffect, useState } from "react"
import { CarouselComponent } from "../CarouselComponent"
import ImageApi from "../../utils/api/ImageApi"
import { LoadingSpinner } from "../loadingSpinner"

// eslint-disable-next-line react/display-name
export const SamsClubWelcomeComponent = React.memo((props) => {

  const [landingPageMainImage, setLandingPageMainImage] = useState("")
  const [srcImage, setSrcImage] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [fileName, setFileName] = useState("")
  const [isMobileVersion, setIsMobileVersion] = useState(false)

  useEffect(() => {

    // eslint-disable-next-line react/prop-types
    if (props.backgrndImg) {
      // eslint-disable-next-line react/prop-types
      setFileName(props.backgrndImg)
    } else {
      setFileName("main_landing_page_img")
    }
    const isMobile = () => {
      const match = window.matchMedia('(pointer:coarse)')
      console.log(`${(match && match.matches) ? 'Mobile' : 'Desktop version'}`)
      setIsMobileVersion(match && match.matches)
    }

    const retrieveStringImage = async () => {

      try {
        setIsLoading(true)

        if (isMobileVersion) {
          setFileName("main_landing_page_img_mob")
        }
        // eslint-disable-next-line react/prop-types
        if (props.offerCampaignIdExpire === "OFFER_EXPIRED") {
          setFileName("main_landing_page_img")
        }

        // eslint-disable-next-line react/prop-types
        if ((props.offerCampaignId !== null && props.offerCampaignId !== 0) || props.offerCampaignIdExpire === "OFFER_EXPIRED") {
          // Get Image for Landing Page
          // eslint-disable-next-line react/prop-types
          await ImageApi.getStringImage(props.offerCampaignId, fileName).then(
            (response) => {
              const offerMainImageLandingPage = response

              setLandingPageMainImage(offerMainImageLandingPage)
              setSrcImage(`data:image/jpg;base64,${landingPageMainImage}`)
              setIsLoading(false)
            }
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        setIsLoading(false)
      }
    }

    isMobile()

    retrieveStringImage()

  }, [landingPageMainImage, props.offerCampaignId, fileName, isMobileVersion, props.backgrndImg, props.offerCampaignIdExpire])

  return (
    isLoading ?
      <>
        <div style={{ textAlign: "center" }}>
          <LoadingSpinner className="mb-3" enabled={isLoading}></LoadingSpinner>
          <h2 className="magenta">Loading...</h2><br />
        </div>
      </>

      :

      <CarouselComponent height="100vh" bgPosition="top center" images={[`'${srcImage}'`]}>
        <div className="row">
          <div className="col mx-auto">
            <p className="text-center title-paramount">{props.backgrndImgText}</p>
          </div>
        </div>
      </CarouselComponent>
  )
})
